import React, { Fragment, useEffect, useState } from 'react';
import moment from 'moment';
import {
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Label,
  Button,
  Row,
  Col,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
  UncontrolledDropdown,
  Spinner,
} from 'reactstrap';
import {
  week,
  month,
  last7Days,
  last30Days,
  last60Days,
  last90Days,
  LastDays,
  year,
} from './../lablesConfig';

import IntlMessages from '../../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import DatePicker from 'react-datepicker';
import 'moment-timezone';
import { API_Email_Stats } from '../../../../../../constants/APIs';
import EmailStatsAreaChart from './emailStatsAreaChart';
import EmailStatsPiChart from './emailStatsPiChart';
import EmailStatistics from './emailStatistics';
import EmailStatsTable from './emailStatsTable';

const today = () => {
  return moment(moment().format('YYYY-MM-DD') + ' 23:59:59')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const daysAgo7 = () => {
  return moment(moment().subtract(6, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const daysAgo30 = () => {
  return moment(moment().subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const daysAgo60 = () => {
  return moment(moment().subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const daysAgo90 = () => {
  return moment(moment().subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const startOfWeek = () => {
  const today = moment();
  return moment(moment(today).isoWeekday(1).format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const endOfWeek = () => {
  const today = moment();
  return moment(moment(today).isoWeekday(7).format('YYYY-MM-DD') + ' 23:59:59')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const startOfMonth = () => {
  return moment(moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'))
    .utc()
    .format('YYYY-MM-DD 00:00:00');
};

const startOfPreviousMonth = () => {
  return moment(
    moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD') +
      ' 00:00:00'
  )
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const startOfThisYear = () => {
  return moment(new Date().getFullYear() + '-01-01' + ' 00:00:00').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};

const startOfLastYear = () => {
  return moment(new Date().getFullYear() - 1 + '-01-01' + ' 00:00:00').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};
const endOfLastYear = () => {
  return moment(new Date().getFullYear() - 1 + '-12-31' + ' 00:00:00').format(
    'YYYY-MM-DD HH:mm:ss'
  );
};

const endOfPreviousMonth = () => {
  return moment(
    moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD') +
      ' 23:59:59'
  )
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const endOfMonth = () => {
  return moment(moment().endOf('month').format('YYYY-MM-DD') + ' 23:59:59')
    .utc()
    .format('YYYY-MM-DD HH:mm:ss');
};

const topicsUsageColumns = [
  {
    Header: 'Topic',
    accessor: 'item',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Summaries',
    accessor: 'totalSummaries',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
  {
    Header: 'AI Replies',
    accessor: 'totalAiReplies',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];

const emailUsgaeColumns = [
  {
    Header: 'Email',
    accessor: 'item',
    Cell: (props) => <p className="ml-2">{props.value}</p>,
  },
  {
    Header: 'Summaries',
    accessor: 'totalSummaries',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
  {
    Header: 'AI Replies',
    accessor: 'totalAiReplies',
    Cell: (props) => <p className="ml-3">{props.value}</p>,
  },
];

const EmailStats = ({ emailIntegrtions, propertyId, timeZone }) => {
  moment.tz.setDefault(timeZone);
  const [buttonText, setButtonText] = useState(
    <IntlMessages id="dashboards.last-7-days" />
  );
  const [labels, setLabels] = useState(last7Days);
  const [isShow, setIsShow] = useState(false);
  const [isError, setError] = useState(false);
  const [message, setMessage] = useState('');
  const [filterDate, setFilterDate] = useState(false);

  const [startDate, setStartDate] = useState(moment().subtract(15, 'days'));
  const [endDate, setEndDate] = useState(moment());

  const [isThreadSummaryChartLoading, setIsThreadSummaryChartLoading] =
    useState(true);
  const [isAIRepliesChatLoading, setIsAIRepliesChatLoading] = useState(true);
  const [isEmailStatsCountLoading, setIsEmailStatsCountLoading] =
    useState(true);
  const [emailPiChartLoading, setEmailPiChartLoading] = useState(true);

  const [emailPiChartData, setEmailPiChartData] = useState();
  const [emailStatData, setEmailStatsData] = useState();
  const [aIRepliesData, setAIRepliesData] = useState();
  const [emailStatsCount, setEmailStatsCount] = useState();

  const handleStartDate = (date) => setStartDate(date);

  const handleEndDate = (date) => setEndDate(date);

  const handleFilter = () => {
    let diff = endDate.diff(startDate, 'days');
    setButtonText('Date Range');
    if (diff > 365) {
      setMessage('The start and end date must be within a year of each other.');
      setError(true);
      return;
    }
    if (diff > 90) {
      setIsShow(false);
      setLabels(year);
      handleDateFilter(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59',
        true
      );
      setFilterDate(true);
    } else {
      if (diff >= 60) setLabels(LastDays(startDate, endDate));
      else if (diff >= 30) setLabels(LastDays(startDate, endDate));
      else if (diff >= 7) setLabels(LastDays(startDate, endDate));
      else setLabels(LastDays(startDate, endDate));
      setIsShow(false);
      handleDateFilter(
        moment(startDate).format('YYYY-MM-DD 00:00:00'),
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59',
        false
      );
      setFilterDate(true);
    }
  };

  const handleDateFilter = (startDate, endDate, isMonth) => {
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);

    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        dateFrom: startDate,
        dateTo: endDate,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        groupId: '73574010-2f33-4b41-8b8a-09d18b025a56',
        propertyId: 'e655dab2-987b-4683-ad9b-599814b414b6',
        isMonth: isMonth,
        dateFrom: startDate,
        dateTo: endDate,
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectLast7Days = () => {
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-7-days" />);
    setLabels(last7Days);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: daysAgo7(),
        dateTo: today(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectLast30Days = () => {
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-30-days" />);
    setLabels(last30Days);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: daysAgo30(),
        dateTo: today(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectLast60Days = () => {
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-60-days" />);
    setLabels(last60Days);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: daysAgo60(),
        dateTo: today(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectLast90Days = () => {
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.last-90-days" />);
    setLabels(last90Days);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: daysAgo90(),
        dateTo: today(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectThisWeek = () => {
    setFilterDate(false);
    setButtonText(<IntlMessages id="dashboards.this-week" />);
    setLabels(week);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: startOfWeek(),
        dateTo: endOfWeek(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectThisMonth = () => {
    setButtonText(<IntlMessages id="dashboards.this-month" />);
    setLabels(month);
    setFilterDate(false);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: startOfMonth(),
        dateTo: endOfMonth(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectPreviousMonth = () => {
    setButtonText(<IntlMessages id="dashboards.previous-month" />);
    setLabels(month);
    setFilterDate(false);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: false,
        dateFrom: startOfPreviousMonth(),
        dateTo: endOfPreviousMonth(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectThisYear = () => {
    setButtonText(<IntlMessages id="dashboards.yeartodate" />);
    setLabels(year);
    setFilterDate(false);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: true,
        dateFrom: startOfThisYear(),
        dateTo: today(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  const selectLastYear = () => {
    setButtonText(<IntlMessages id="dashboards.lastyear" />);
    setLabels(year);
    setFilterDate(false);
    setIsThreadSummaryChartLoading(true);
    setIsAIRepliesChatLoading(true);
    setIsEmailStatsCountLoading(true);
    setEmailPiChartLoading(true);
    AxiosAPI({
      method: 'post',
      url: `${API_Email_Stats}`,
      data: {
        groupId: getGroupID(),
        propertyId: propertyId === '-1' ? null : propertyId,
        integrations:
          emailIntegrtions !== undefined && emailIntegrtions.length > 0
            ? emailIntegrtions.map((m) => m.id)
            : [],
        isMonth: true,
        dateFrom: startOfLastYear(),
        dateTo: endOfLastYear(),
      },
    }).then((res) => {
      if (res.data?.threadSummaryChart) {
        setEmailStatsData(res.data);
      }
    });
  };

  useEffect(() => {
    if (emailIntegrtions !== undefined) {
      selectLast7Days();
    }
  }, [propertyId]);
  return (
    <Fragment>
      <Row>
        <Col xxs="12" className="mb-2">
          <Fragment>
            {filterDate === true && (
              <div className="float-left mt-2">
                <span className="mr-2">
                  <b>From : </b>
                  {moment(startDate).format('DD')}/
                  {moment(startDate).format('MM')}/
                  {moment(startDate).format('YYYY')}
                </span>
                <span className="ml-2">
                  <b>To : </b>
                  {moment(endDate).format('DD')}/{moment(endDate).format('MM')}/
                  {moment(endDate).format('YYYY')}
                </span>
              </div>
            )}
            <div className="btn-group float-right float-none-xs mb-3">
              <UncontrolledDropdown>
                <DropdownToggle
                  caret
                  color="primary"
                  className="btn-xs"
                  outline
                >
                  {buttonText}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={selectLast7Days}>
                    <IntlMessages id="dashboards.last-7-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast30Days}>
                    <IntlMessages id="dashboards.last-30-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast60Days}>
                    <IntlMessages id="dashboards.last-60-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLast90Days}>
                    <IntlMessages id="dashboards.last-90-days" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisWeek}>
                    <IntlMessages id="dashboards.this-week" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisMonth}>
                    <IntlMessages id="dashboards.this-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectPreviousMonth}>
                    <IntlMessages id="dashboards.previous-month" />
                  </DropdownItem>
                  <DropdownItem onClick={selectThisYear}>
                    <IntlMessages id="dashboards.yeartodate" />
                  </DropdownItem>
                  <DropdownItem onClick={selectLastYear}>
                    <IntlMessages id="dashboards.lastyear" />
                  </DropdownItem>
                  <DropdownItem onClick={() => setIsShow(!isShow)}>
                    Date Range
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </Fragment>
        </Col>
      </Row>
      <Row>
        <Col sm="12" md="6" className="mb-4">
          {emailStatData?.threadSummaryChart ? (
            <EmailStatsAreaChart
              labels={labels}
              title={'dashboards.thread-summary-title'}
              subtitle={'dashboards.thread-summary-subtitle'}
              data={emailStatData?.threadSummaryChart}
            />
          ) : (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          )}
        </Col>
        <Col sm="12" md="6" className="mb-4">
          {emailStatData?.aiRepliesChart ? (
            <EmailStatsAreaChart
              labels={labels}
              data={emailStatData?.aiRepliesChart}
              title={'dashboards.ai-replies-title'}
              subtitle={'dashboards.ai-replies-subtitle'}
            />
          ) : (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col sm="12" md="6" className="mb-4">
          {emailStatData?.topicsUsageInfo ? (
            <EmailStatsTable
              labels={topicsUsageColumns}
              data={emailStatData?.topicsUsageInfo}
              title={'dashboards.common-email-reasons'}
              subtitle={'dashboards.topics-in-emails'}
            />
          ) : (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          )}
        </Col>
        <Col sm="12" md="6" className="mb-4">
          {emailStatData?.emailUsageInfo ? (
            <EmailStatsTable
              labels={emailUsgaeColumns}
              data={emailStatData?.emailUsageInfo}
              title={'dashboards.email-assistant-usage'}
              subtitle={'dashboards.usage-by-email-address'}
            />
          ) : (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          )}
        </Col>
      </Row>
      <Row>
        <Col sm="12" md="3" className="mb-4">
          {emailStatData?.uregencyData ? (
            <EmailStatsPiChart
              labels={['High', 'Medium', 'Low']}
              title={'dashboards.urgency'}
              subtitle={''}
              data={emailStatData?.uregencyData}
            />
          ) : (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          )}
        </Col>
        <Col sm="12" md="3" className="mb-4">
          {emailStatData?.sentimentData ? (
            <EmailStatsPiChart
              title={'dashboards.sentiment'}
              subtitle={''}
              labels={['Positive', 'Neutral', 'Negative']}
              data={emailStatData?.sentimentData}
            />
          ) : (
            <div className="text-center">
              <Spinner color="primary" className="mb-1" />
            </div>
          )}
        </Col>
        <Col sm="12" md="6" className="mb-4">
          <div className="iconcards-row row d-flex">
            <EmailStatistics
              name={'Summary'}
              title={'dashboards.total-thread-summary-title'}
              count={
                emailStatData?.totalThreadSummary
                  ? emailStatData.totalThreadSummary
                  : 0
              }
            />
            <EmailStatistics
              name={'Replies'}
              title={'dashboards.total-ai-replies-title'}
              count={
                emailStatData?.totalAiReplies ? emailStatData.totalAiReplies : 0
              }
            />
            <EmailStatistics
              name={'Copied'}
              title={'dashboards.total-draft-copied'}
              count={
                emailStatData?.totalCopyDraft ? emailStatData.totalCopyDraft : 0
              }
            />
          </div>
        </Col>
      </Row>

      <Modal
        isOpen={isShow}
        toggle={() => setIsShow(!isShow)}
        style={{ borderRadius: '10px' }}
      >
        <ModalHeader toggle={() => setIsShow(!isShow)}>Date Range</ModalHeader>
        <ModalBody>
          <Row>
            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label>Start Date</Label>
                <DatePicker
                  style={{ borderRadius: '10px' }}
                  selected={startDate}
                  onChange={handleStartDate}
                  placeholderText="Start Date"
                  dateFormat="DD/MM/YYYY"
                />
              </FormGroup>
            </Colxx>

            <Colxx md="4" className="mb-2">
              <FormGroup>
                <Label>End Date</Label>
                <DatePicker
                  style={{ borderRadius: '10px' }}
                  selected={endDate}
                  onChange={handleEndDate}
                  placeholderText="End Date"
                  dateFormat="DD/MM/YYYY"
                />
              </FormGroup>
            </Colxx>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleFilter()}>
            Submit
          </Button>
          <Button className="ml-2" onClick={() => setIsShow(!isShow)}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};
export default EmailStats;
